export const msalConfig = {
  auth: {
    clientId: '39105664-6265-438e-ab3d-8ba5cfe22eac',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
  extraScopesToConsent: ['api://7536153a-4bb9-47e4-8246-7d0d89ae008f/User_Access'],
};

export const apiRequest = {
  scopes: ['api://7536153a-4bb9-47e4-8246-7d0d89ae008f/User_Access'],
};
